<template>
  <v-app id="app">
    <template v-if="isAppReady">
      <template v-if="user">
        <v-navigation-drawer
            v-if="user && !isXs && !isPosAdmin && !isFullScreenRoute"
            v-show="!isPrinting"
            fixed
            app
            mini-variant-width="60"
            class="glass-sidebar  pt-3"
            dark
            v-model="showDrawer"
            right
            permanent
            :mini-variant.sync="mini"
            :expand-on-hover="rail"
            :mobile-breakpoint="0"
            location="right"
        >
          <div class="rounded">
            <v-row class="items-center">
              <v-img
                  v-if="mini"
                  class="mr-4 mt-5 rounded-lg"
                  src="/img/icons/e-logo.png"
                  max-height="50"
                  max-width="50"
              ></v-img>
              <v-img
                  v-if="!mini"
                  class="mr-15 mt-5 mb-4 rounded-lg"
                  src="/img/icons/exuni-logo.png"
                  max-height="100"
                  max-width="160"
              ></v-img>
              <v-btn
                  icon
                  class="mt-1 ml-4"
                  depressed
                  height="35"
                  width="35"
                  @click.stop="rail = !rail"
                  color="transparent"
              >
              </v-btn>
            </v-row>
          </div>
          <m-navbar @logout="logout" />
        </v-navigation-drawer>

        <v-app-bar
            app
            flat
            clipped-left
            class="bg-gradient-to-r from-gray-800 to-gray-900"
            v-if="user && !isXs && !isPosAdmin && !isFullScreenRoute"
            height="80"
            v-show="!isPrinting"
        >
          <v-spacer></v-spacer>
          <div class="mr-4 mt-2">
            <v-menu offset-y transition="slide-y-transition" open-on-hover>
              <template v-slot:activator="{ on, attrs }">
                <v-avatar
                    v-bind="attrs"
                    v-on="on"
                    size="38"
                    class="mt-4 rounded-lg"
                    :color="user.profile_picture ? '#39506D' : '#28506D'"
                >
                  <v-img
                      v-if="user.profile_picture"
                      :src="img_source(user.profile_picture)"
                      max-width="36"
                      max-height="36"
                  ></v-img>
                  <v-img
                      v-else
                      src="/img/icons/profile_dark.svg"
                      max-width="36"
                      max-height="36"
                  ></v-img>
                </v-avatar>
              </template>

              <v-list class="glass-dropdown">
                <v-list-item :to="{ name: 'Profile' }">
                  <v-list-item-avatar
                      size="35"
                      :color="user.profile_picture ? '#11151C' : '#1A1D27'"
                  >
                    <v-img
                        v-if="user.profile_picture"
                        :src="img_source(user.profile_picture)"
                    ></v-img>
                    <v-img v-else src="/img/icons/profile_dark.svg"></v-img>
                  </v-list-item-avatar>
                  <v-list-item-title class="text-gray-50">
                    {{ user.name || user.username }}
                  </v-list-item-title>
                </v-list-item>
                <v-divider class=""></v-divider>
                <v-list-item
                    @click="logout"
                    class=" transition-all duration-300"
                >
                  <v-list-item-avatar size="30">
                    <v-img src="/img/icons/log.svg"></v-img>
                  </v-list-item-avatar>
                  <v-list-item-title class="text-gray-50">خروج</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </v-app-bar>

        <v-app-bar
            flat
            app
            height="30"
            clipped-left
            v-if="!isXs && !isFullScreenRoute"
            v-show="!isPrinting"
        >
          <m-system-bar />
        </v-app-bar>

        <div
            v-if="user && isXs && !isPrinting && !isPosAdmin && !isFullScreenRoute"
            class="fixed top-0 left-0 right-0 h-[60px] bg-gray-900 flex items-center px-4 z-40"
        >
          <button
              class="rounded-full   transition-colors"
              @click="showMobileDrawer = true"
          >
            <img src="/img/icons/menu.svg" class="w-9 h-9" alt="Menu" />
          </button>
          <img src="/img/icons/exuni-new.png" class="w-[80px] mr-4" alt="Logo" />
          <div class="flex-1"></div>

          <v-avatar
              @click="$router.push({ name: 'Profile' })"
              size="35"
              class="rounded-lg"
              :color="user.profile_picture ? '#1A1D27' : '#11151C'"
          >
            <v-img
                v-if="user.profile_picture"
                :src="img_source(user.profile_picture)"
            ></v-img>
            <v-img
                v-else
                src="/img/icons/profile_dark.svg"
                max-width="25"
                max-height="25"
            ></v-img>
          </v-avatar>
          <button
              style="margin-left: auto; margin-right: 10px"
              class=" rounded-full   transition-colors"
              @click="back"
          >
            <img src="/img/icons/back.svg" class="w-9 h-9" alt="Back" />
          </button>
        </div>

        <div
            v-if="user && isXs && !isPrinting && !isPosAdmin && !isFullScreenRoute"
            class=" transition-all duration-300 ease-in-out"
            :class="{'pointer-events-none': !showMobileDrawer}"
        >
          <div
              class="fixed top-0 right-0 h-full w-[280px] bg-gray-800  text-gray-50  transition-transform duration-300 ease-in-out flex flex-col z-50"
              :class="{'translate-x-full': !showMobileDrawer, 'translate-x-0': showMobileDrawer}"
          >
            <div class="grid grid-cols-2 gap-6 mx-2 py-4">
              <svg
                  @click="showMobileDrawer = false"
                  xmlns="http://www.w3.org/2000/svg"
                  class="mt-3 mr-5 h-8 w-8 text-gray-50"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
              >
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
              <img
                  class="h-[50px]"
                  src="/img/icons/exuni-new.png"
                  alt="Logo"
              />
            </div>

            <div
                class="flex-1 overflow-y-auto pt-2"
                @click.self="showMobileDrawer = false"
            >
              <m-navbar
                  class="w-full"
                  @item-selected="showMobileDrawer = false"
                  @logout="logout"
              />
            </div>
          </div>
        </div>
      </template>

      <v-main :class="mainClass">
        <div
            @click="showMobileDrawer = false"
            v-if="showMobileDrawer && !isCashierLayout && !isFullScreenRoute"
            class="fixed inset-0 z-40"
        ></div>

        <v-container
            :class="containerClass"
            fluid
        >
          <router-view/>
        </v-container>
      </v-main>
    </template>
    <loader/>
  </v-app>
</template>

<script>
import mNavbar from "@/components/Navbar";
import mFooter from "@/components/Footer";
import mSystemBar from "@/components/SystemBar";
import Loader from "@/components/Loader";
import moment from "moment-jalaali";
import { mapState } from "vuex";

export default {
  name: "App",
  components: {
    mNavbar,
    mFooter,
    mSystemBar,
    Loader,
  },
  data() {
    return {
      access: false,
      isAppReady: false,
      showDrawer: false,
      showMobileDrawer: false,
      developersDialog: false,
      timeInterval: null,
      mini: true,
      rail: true,
      dialog: false,
      menu: false,
      message: false,
      drawer: false,
      hints: true,
      user_companies: [],
      next_year: null,
      changeFinancialYearDialog: false,
    };
  },
  computed: {
    serverUrl: {
      get() {
        return localStorage.getItem("serverUrl");
      },
      set(value) {
        localStorage.setItem("serverUrl", value);
      },
    },
    ...mapState({
      snackbar: (state) => state.snackbar,
      user: (state) => state.user,
    }),
    isCashierLayout () {
      return !!(this.user && this.user.user_type === 'cshr')
    },

    isPosAdmin () {
      return this.isCashierLayout
    },

    isFullScreenRoute () {
      return !!(this.$route.meta && this.$route.meta.fullScreen)
    },

    mainClass () {
      if (this.isFullScreenRoute) {
        return 'packing-fullscreen-main'
      }

      if (this.isCashierLayout) {
        return 'pos-fullscreen-main'
      }

      return this.isXs
          ? 'app-background-color mt-15'
          : 'app-background-color mt-min'
    },

    containerClass () {
      if (this.isFullScreenRoute) {
        return 'packing-fullscreen-container'
      }

      if (this.isCashierLayout) {
        return 'pos-fullscreen-container'
      }

      return 'app-background-color left-scroll-container'
    },
  },
  created() {
    this.log(`server url is : ${this.getServerUrl()}`);
    this.getDateTime();
    this.enforcePosAdminRoute()
    this.enforceSupportAdminRoute()
    this.enforceShopAdminRoute()

  },
  mounted() {
    this.EventBus.$on('close-mobile-drawer', () => {
      this.showMobileDrawer = false;
    });
    const closeWindow = (data) => {
      if (data.appId != this.appId) {
        window.close();
      }
    };
    this.tabOn("logout", closeWindow);

    this.$nextTick(() => {
      if (this.isXs) {
        this.showMobileDrawer = false;
      }
    });
  },
  beforeDestroy() {
    this.EventBus.$off('close-mobile-drawer');
  },
  watch: {
    '$route.name' () {
      this.enforcePosAdminRoute()
      this.enforceSupportAdminRoute()
      this.enforceShopAdminRoute()

    },
    user () {
      this.enforcePosAdminRoute()
      this.enforceSupportAdminRoute()
      this.enforceShopAdminRoute()
    }
  },
  methods: {
    enforcePosAdminRoute () {
      if (this.user && this.user.user_type === 'cshr') {
        if (!['PosNewDashboard', 'Login'].includes(this.$route.name)) {
          this.$router.replace({ name: 'PosNewDashboard' }).catch(() => {})
        }
      }
    },

    enforceSupportAdminRoute () {
      if (this.user && this.user.user_type === 'suprt') {
        if (!['WalletTopUpFromOrder', 'SupportOrdersList', 'AdminOrderDetail', 'Login'].includes(this.$route.name)) {
          this.$router.replace({ name: 'SupportOrdersList' }).catch(() => {})
        }
      }
    },

    enforceShopAdminRoute () {
      if (this.user && this.user.username === '09013840011') {
        if (!['PriceSearch', 'Login'].includes(this.$route.name)) {
          this.$router.replace({ name: 'PriceSearch' }).catch(() => {})
        }
      }
    },
    back() {
      window.history.back();
    },
    routeClick(routeName) {
      if (this.$route.name == routeName) {
        this.EventBus.$emit("sameRouteClick");
      }
    },
    getDateTime() {
      this.request({
        url: this.endpoint(`home/time`),
        method: "get",
        token: false,
        success: (data) => {
          let now = moment.unix(data.time);
          this.$store.commit("setTime", now);
          this.isAppReady = true;

          this.timeInterval = window.setInterval(() => {
            this.$store.commit("setTime", this.serverNow.add(1, "second"));
          }, 1000);
        },
      });
    },
    logout() {
      this.setToken("");
      this.$store.commit("setUser", null);
      if (this.$route.name != "Login") {
        let url = this.$router.resolve({name: "Login"});
        window.location = url;
      }
      this.tabEmit("logout");
    },
  },
};
</script>

<style lang="scss">
/* حذف border از app bar ها */
.v-app-bar {
  border: none !important;
  border-bottom: none !important;
}

/* حذف border مخصوص برای app bar اصلی */
.v-app-bar.bg-gradient-to-r {
  border-bottom: none !important;
  box-shadow: none !important; /* اگر می‌خواهید سایه هم نباشد */
}

.v-app-bar.glass-system-bar,
.v-app-bar:not(.bg-gradient-to-r) {
  border-bottom: none !important;
  border-top: none !important;
}

/* اگر از کلاس glass-header استفاده می‌کنید */
.glass-header {
  border: none !important;
  border-bottom: none !important;
}

/* برای حالت موبایل */
.glass-mobile-header {
  border: none !important;
  border-bottom: none !important;
}
@import "./styles/main";

.mt-min {
  margin-top: -5px;
}

.left-scroll-container {
  direction: rtl;
  overflow-y: auto;
  height: 100vh;
  padding-left: 5px;

}

.left-scroll-container::-webkit-scrollbar {
  width: 12px;
  background-color: rgba(0, 0, 0, 0.18)
}

.left-scroll-container::-webkit-scrollbar-track {
  border-radius: 10px;
  margin: 5px 0;
}

.left-scroll-container::-webkit-scrollbar-thumb {
  background: #000;
  border-radius: 10px;
  border: 3px solid rgba(0, 0, 0, 0.18)
}

.left-scroll-container::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.18)
}

/* Firefox scrollbar styling */
@supports (scrollbar-color: auto) {
  .left-scroll-container {
    scrollbar-color: #1A1D27 #11151C;
  }
}

.glass-sidebar {
  background: #1A1D27 !important;
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
}

.glass-header {
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
}

.glass-system-bar {
  background: #1A1D27 !important;
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
}

.glass-mobile-sidebar {
  background: rgba(59, 1, 125, 0.9) !important;
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  box-shadow: -8px 0 32px 0 rgba(31, 38, 135, 0.15);
}

.glass-mobile-header {
  background: #1A1D27 !important;
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
}

.glass-dropdown {
  background: rgba(#000, 0.9) !important;
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.25);
}

.v-navigation-drawer {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.v-list-item {
  transition: all 0.2s ease !important;
}

@media (max-width: 1263px) {
  .v-navigation-drawer--mini-variant {
    width: 60px !important;
  }
}

::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 3px;
}

::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.3);
  border-radius: 3px;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.9);
}

.glass-mobile-sidebar {
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

body.drawer-open {
  overflow: hidden;
}
.pos-fullscreen-main {
  margin: 0 !important;
  padding: 0 !important;
  background: #020617 !important;
  min-height: 100vh !important;
  width: 100vw !important;

}

.pos-fullscreen-container {
  margin-top: 30px;
  max-width: none !important;
  width: 100vw !important;
  min-height: 100vh !important;
  height: 95vh !important;
  background: #020617 !important;
}

.packing-fullscreen-main {
  margin: 0 !important;
  padding: 0 !important;
  min-height: 100vh !important;
  width: 100vw !important;
}

.packing-fullscreen-container {
  margin: 0 !important;
  padding: 0 !important;
  max-width: none !important;
  width: 100vw !important;
  min-height: 100vh !important;
}
</style>
